import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { take, switchMap } from 'rxjs';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';
import { BrowserService } from '../services/browser.service';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';

function toSnakeCase(str: string): string {
  return str.toLowerCase().trim().replace(/\s+/g, '_');
}

function getCountryCode(browser: BrowserService, countryService: countriesService): string {
  const localStorage = browser.getLocalStorage();
  if (!localStorage) return 'EG'; // SSR fallback
  
  const userRegionStr = localStorage.getItem('UserRegion');
  if (!userRegionStr || userRegionStr === 'undefined') return 'EG'; // Default fallback
  
  try {
    const userRegion = JSON.parse(userRegionStr);
    const countryKey = userRegion?.country ? toSnakeCase(userRegion.country) : 'EG';
    return countryService?.countryCodes[countryKey] || 'EG';
  } catch (e) {
    console.warn('Failed to parse UserRegion from localStorage:', e);
    return 'EG'; // Fallback on parse error
  }
}

export const DevAccessInterceptor: HttpInterceptorFn = (request, next) => {
  const countryService = inject(countriesService);
  const browser = inject(BrowserService);
  const languageService = inject(LanguageService);

  let req = request;

  if (request.url.includes('-dev.')) {
    req = request.clone({
      headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
    });
  }

  if (req.url.includes('suggestions')) {
    return languageService.selectedCountry.pipe(
      take(1),
      switchMap(() => {
        const countryCode = getCountryCode(browser, countryService) || 'EG';

        const clonedReq = req.clone({
          headers: req.headers.set('X-User-Country', countryCode)
        });

        return next(clonedReq);
      })
    );
  }

  return next(req);
};